import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: DeviceState = {};

const keepLastCounts = 16;

export const deviceSlice = createSlice({
	name: "device",
	initialState,
	reducers: {
		updateDevice: (state, action: PayloadAction<{ id: number; device: Partial<Device> }>) => {
			state[action.payload.id] = { ...(state[action.payload.id] || {}), ...action.payload.device };
			if (action.payload.device.msgType === "status") {
				if (state[action.payload.id].currentCounts) {
					if (state[action.payload.id].currentCounts.length >= keepLastCounts) {
						state[action.payload.id].currentCounts.shift();
					}
					state[action.payload.id].currentCounts.push({ date: action.payload.device.DeviceTime || 0, count: action.payload.device.Quantity || 0 });
				} else {
					state[action.payload.id].currentCounts = [{ date: action.payload.device.DeviceTime || 0, count: action.payload.device.Quantity || 0 }];
				}
			}
		},
	},
});

export const { updateDevice } = deviceSlice.actions;

export default deviceSlice.reducer;
